import { withLayout } from 'pages/Layout'
import UserDocumentsPage from './UserDocumentsPage'

export default withLayout('documents',UserDocumentsPage)
